import React, { Suspense } from "react";

import { Layout } from "@/components/ui";
import { useAuth } from "@/contexts/auth/useAuth";
import { useGroupContext } from "@/contexts/group-context";
import LinkFooter from "@/features/ui/components/link-footer";
import {
  CtaBanner,
  GroupMediaPanel,
  SignUpPanel,
  SuggestedGroupsPanel,
} from "@/features/ui/util/async-components";

interface GroupPageProps {
  children: React.ReactNode;
}

/** Page to display group search feature. */
const GroupSearchPage = ({ children }: GroupPageProps) => {
  const { currentAccount } = useAuth();
  const { group } = useGroupContext();

  return (
    <>
      <Layout.Main>
        {children}

        {!currentAccount && (
          <Suspense fallback={null}>
            <CtaBanner key="cta-banner" />
          </Suspense>
        )}
      </Layout.Main>

      <Layout.Aside>
        {!currentAccount && (
          <Suspense fallback={null}>
            <SignUpPanel key="sign-up-panel" />
          </Suspense>
        )}

        {currentAccount && group && (
          <Suspense fallback={null}>
            <GroupMediaPanel group={group} />
          </Suspense>
        )}

        {currentAccount && (
          <Suspense fallback={null}>
            <SuggestedGroupsPanel />
          </Suspense>
        )}

        <LinkFooter key="link-footer" />
      </Layout.Aside>
    </>
  );
};

export default GroupSearchPage;
